import '@testing-library/jest-dom';
import { render, screen } from '@testing-library/react';

import { CheckboxButton } from './CheckboxButton';

const onClickSpy = jest.fn();

describe('CheckboxButton', () => {
  it('should render', () => {
    render(<CheckboxButton label="2.1" value="4" onSetValue={onClickSpy} />);
    const checkbox = screen.getByRole('checkbox');
    expect(checkbox).toBeInTheDocument();
  });

  it('should be checked if clicked', () => {
    render(<CheckboxButton label="2.1" value="4" onSetValue={onClickSpy} />);
    const checkbox = screen.getByRole('checkbox');
    expect(checkbox).toBeInTheDocument();
    checkbox.click();
    expect(checkbox).toBeChecked();
    expect(onClickSpy).toHaveBeenCalledTimes(1);
  });

  it('should be disabled', () => {
    render(<CheckboxButton label="2.1" value="4" onSetValue={onClickSpy} disabled={true} />);
    const checkbox = screen.getByRole('checkbox');
    expect(checkbox).toBeInTheDocument();
    expect(checkbox).toBeDisabled();
  });

  it('should show noValid', () => {
    render(<CheckboxButton label="2.1" value="4" onSetValue={onClickSpy} notValid={true} />);
    const checkbox = screen.getByRole('checkbox');
    expect(checkbox).toBeInTheDocument();
    const label = screen.getByText('2.1');
    expect(label).toHaveClass('checkbox-button--not-valid');
  });

  it('should render single variant', () => {
    render(<CheckboxButton label="2.1" value="4" onSetValue={onClickSpy} notValid={true} />);
    const checkbox = screen.getByRole('checkbox');
    expect(checkbox).toBeInTheDocument();
    const label = screen.getByText('2.1');
    expect(label).toHaveClass('checkbox-button--single');
  });

  it('should render start variant', () => {
    render(<CheckboxButton label="2.1" value="4" onSetValue={onClickSpy} notValid={true} variant="start" />);
    const checkbox = screen.getByRole('checkbox');
    expect(checkbox).toBeInTheDocument();
    const label = screen.getByText('2.1');
    expect(label).toHaveClass('checkbox-button--start');
  });

  it('should render middle variant', () => {
    render(<CheckboxButton label="2.1" value="4" onSetValue={onClickSpy} notValid={true} variant="middle" />);
    const checkbox = screen.getByRole('checkbox');
    expect(checkbox).toBeInTheDocument();
    const label = screen.getByText('2.1');
    expect(label).toHaveClass('checkbox-button--middle');
  });

  it('should render end variant', () => {
    render(<CheckboxButton label="2.1" value="4" onSetValue={onClickSpy} notValid={true} variant="end" />);
    const checkbox = screen.getByRole('checkbox');
    expect(checkbox).toBeInTheDocument();
    const label = screen.getByText('2.1');
    expect(label).toHaveClass('checkbox-button--end');
  });
});
